import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import {
  useGetLoginsPerMonthQuery,
  useGetUsersStatsFullQuery,
} from "../../services/API/statisticsAPI";
import exportAllExports from "./Export/exportAllExports";
import ChartCard from "./ChartCard";
import CsvDownloadButton from "./CsvDownloadButton";
import { baseOptions, monthlyScales, nullifyFutureMonths, yearBarDataset } from "./chartTheme";

const LoginsPerMonthDurationStats = () => {
  const { t } = useTranslation(["translation", "statistics"]);
  const todayYear = new Date().getFullYear();

  const { data: loginsPerMonth } = useGetLoginsPerMonthQuery(undefined, {
    pollingInterval: 60000,
  });

  const { data: userStatsFullData } = useGetUsersStatsFullQuery(undefined, {
    pollingInterval: 60000,
  });

  // Initialize arrays with 12 months (0-11) for each year
  let datasetData = [
    new Array(12).fill(0), // Current year data
    new Array(12).fill(0), // Previous year data
  ];

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  loginsPerMonth?.map((item) => {
    const yearIndex = todayYear - item._id.year;
    const monthIndex = item._id.month - 1;

    // Only process if yearIndex is within bounds (0 or 1) and monthIndex is valid
    if (yearIndex >= 0 && yearIndex < datasetData.length && monthIndex >= 0 && monthIndex < 12) {
      datasetData[yearIndex][monthIndex] =
        Math.round((item?.duration * 100) / (60 * 60)) / 100 ?? 0;
    }
    return null;
  });

  const loginsDurationData = {
    labels,
    datasets: [
      yearBarDataset({
        label: `${todayYear - 1}`,
        data: datasetData[1],
        isCurrentYear: false,
      }),
      yearBarDataset({
        label: `${todayYear}`,
        data: nullifyFutureMonths(datasetData[0]),
        isCurrentYear: true,
      }),
    ],
  };

  const options = {
    ...baseOptions(),
    scales: monthlyScales(),
  };

  return (
    <ChartCard
      title={t("user.durationpermonth", { ns: "statistics" })}
      action={
        <CsvDownloadButton
          data={exportAllExports.exportUserIteractionsFull(userStatsFullData ?? [])}
          headers={exportAllExports.headersUserIteractionsFull()}
          filename={"stats_usage_per_month.csv"}
        />
      }
    >
      <Bar options={options} data={loginsDurationData} />
    </ChartCard>
  );
};

export default LoginsPerMonthDurationStats;
